import crossIcon from '@assets/misc/cross-icon.svg';
import { displayTime } from '@global/helpers/general';
import { Box, Typography } from '@mui/material';
import GenericFormAlert from './generic';

export default function Closed({ txnInfo, contactUs }: { txnInfo: any, contactUs: () => void }) {
  return (
    <>
      <GenericFormAlert
        theme="light"
        title={'Verification closed'}
        icon={<img src={crossIcon} alt="Cross Icon" />}
        caption={
          <Box sx={{ display: 'flex', flexFlow: 'column', alignItems: 'center' }}>
            <Typography variant="body2">
              Your verification was closed on {displayTime(txnInfo?.updatedAt, 'Do MMMM YYYY')}.
            </Typography>
            <Typography variant="body2">
              <Box
                component="span"
                sx={{
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  color: 'primary.main'
                }}
                onClick={() => {
                  contactUs();
                }}>
                {'Contact us'}
              </Box>
              {' for any assistance.'}
            </Typography>
          </Box>
        }
      />
    </>
  );
}
